import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash-es';

import { DateTimeFormatOptions } from '../date-format.options';

@Pipe({
  name: 'libFullDateTime',
  standalone: false
})
export class FullDateTimePipe implements PipeTransform {
  transform(date: string | Date | undefined, locale: string, options: DateTimeFormatOptions): string {
    if (date === undefined || (typeof date === 'string' && isEmpty(date))) {
      return '';
    }

    const dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.toLocaleString(locale, options as any);
  }
}
